module.exports = __webpack_public_path__ + "static/media/upload.595e86f6.svg";